module.exports = __webpack_public_path__ + "static/media/Mapmarker.992f48ca.svg";